{
  "FILTER": {
    "AI_PROMPT": "Filtro AI",
    "TITLE": "Filtra conversazioni",
    "SUBTITLE": "Add your filters below and hit 'Apply filters' to cut through the chat clutter.",
    "EDIT_CUSTOM_FILTER": "Edit Folder",
    "CUSTOM_VIEWS_SUBTITLE": "Add or remove filters and update your folder.",
    "ADD_NEW_FILTER": "Add filter",
    "FILTER_DELETE_ERROR": "Oops, looks like we can't save nothing! Please add at least one filter to save it.",
    "SUBMIT_BUTTON_LABEL": "Applica filtri",
    "UPDATE_BUTTON_LABEL": "Update folder",
    "CANCEL_BUTTON_LABEL": "Annulla",
    "CLEAR_BUTTON_LABEL": "Clear filters",
    "FOLDER_LABEL": "Folder Name",
    "TEAMS_LABEL": "Condividi con",
    "PARENT_FOLDER_LABEL": "Cartella principale",
    "NO_PARENT_FOLDER": "Nessuna cartella principale",
    "BACKGROUND_COLOR_LABEL": "Colore di sfondo",
    "COLOR_LABEL": "Colore",
    "SELECT_COLOR": "Seleziona colore",
    "CLEAR_SELECTION": "Cancella selezione",
    "SORT_BY_LABEL": "Ordina per",
    "FOLDER_QUERY_LABEL": "Folder Query",
    "EMPTY_VALUE_ERROR": "Il valore è obbligatorio.",
    "TOOLTIP_LABEL": "Filtra conversazioni",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "E",
      "OR": "O"
    },
    "INPUT_PLACEHOLDER": "Enter value",
    "OPERATOR_LABELS": {
      "present": "Presente",
      "not_present": "Non presente",
      "present_with_answer": "Presente con risposta",
      "present_without_answer": "Presente senza risposta",
      "equal_to": "Uguale a",
      "not_equal_to": "Non uguale a",
      "does_not_contain": "Non contiene",
      "is_present": "È presente",
      "is_not_present": "Non è presente",
      "is_greater_than": "È maggiore di",
      "is_less_than": "È minore di",
      "is_greater_than_or_equal": "È maggiore o uguale a",
      "is_less_than_or_equal": "È minore o uguale a",
      "newer_than_days": "Più recente di x giorni (incluso)",
      "older_than_days": "Più vecchio di x giorni (incluso)",
      "starts_with": "Inizia con",
      "equalTo": "Uguale a",
      "notEqualTo": "Non uguale a",
      "contains": "Contiene",
      "doesNotContain": "Non contiene",
      "isPresent": "È presente",
      "isNotPresent": "Non è presente",
      "isGreaterThan": "È maggiore di",
      "isLessThan": "È minore di",
      "isGreaterThanOrEqual": "È maggiore o uguale a",
      "isLessThanOrEqual": "È minore o uguale a",
      "startsWith": "Inizia con"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "Vero",
      "FALSE": "Falso"
    },
    "ATTRIBUTES": {
      "STATUS": "Stato",
      "ASSIGNEE_NAME": "Assignee name",
      "INBOX_NAME": "Nome casella",
      "TEAM_NAME": "Nome del team",
      "CONVERSATION_IDENTIFIER": "Conversation identifier",
      "CAMPAIGN_NAME": "Campaign name",
      "LABELS": "Etichette",
      "BROWSER_LANGUAGE": "Browser language",
      "PRIORITY": "Priorità",
      "COUNTRY_NAME": "Country name",
      "REFERER_LINK": "Link referente",
      "CUSTOM_ATTRIBUTE_LIST": "Elenco",
      "CUSTOM_ATTRIBUTE_TEXT": "Testo",
      "CUSTOM_ATTRIBUTE_NUMBER": "Numero",
      "CUSTOM_ATTRIBUTE_LINK": "Link",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Checkbox",
      "CREATED_AT": "Creato il",
      "LAST_ACTIVITY": "Last activity",
      "LAST_CUSTOMER_MESSAGE_AT": "Ultimo messaggio del cliente",
      "PHONE_CALL": "Chiamata telefonica",
      "RATING": "Valutazione",
      "CSAT": "CSAT"
    },
    "PHONE_CALL_TYPES": {
      "INBOUND": "In entrata",
      "OUTBOUND": "In uscita",
      "MISSED": "Persa",
      "UNHANDLED_MISSED": "Persa non gestita"
    },
    "RATING_TYPES": {
      "UP": "Pollice in su",
      "DOWN": "Pollice in giù"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Il valore è obbligatorio",
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Il valore deve essere compreso tra 0 e 998"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Standard filters",
      "ADDITIONAL_FILTERS": "Additional filters",
      "CUSTOM_ATTRIBUTES": "Custom attributes"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "Vuoi salvare questo filtro?",
        "LABEL": "Dai un nome a questo filtro",
        "PLACEHOLDER": "Name your filter to refer it later.",
        "ERROR_MESSAGE": "Il nome è obbligatorio.",
        "SAVE_BUTTON": "Salva filtro",
        "CANCEL_BUTTON": "Annulla",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Cartella creata con successo.",
          "ERROR_MESSAGE": "Errore durante la creazione della cartella."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segmento creato con successo.",
          "ERROR_MESSAGE": "Errore durante la creazione del segmento."
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "Edit folder",
        "API_FOLDERS": {
          "ERROR_MESSAGE": "Errore durante l'aggiornamento della cartella."
        }
      },
      "DELETE": {
        "DELETE_BUTTON": "Elimina filtro",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "Conferma eliminazione",
            "MESSAGE": "Sei sicuro di voler eliminare il filtro ",
            "YES": "Yes, delete",
            "NO": "No, mantienilo"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Cartella eliminata con successo.",
          "ERROR_MESSAGE": "Errore durante l'eliminazione della cartella."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segmento eliminato con successo.",
          "ERROR_MESSAGE": "Errore durante l'eliminazione del segmento."
        }
      }
    }
  }
}
